import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { naira } from "@/lib/format";

export default function Products() {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/public/products").then(({ data }) => setProducts(data)).catch(() => {});
    api.get("/public/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Products</h1>
      <p className="mt-3 text-lg text-slate-600 max-w-2xl">
        We supply premium-grade fuel in bulk to organisations across Nigeria.
      </p>

      <div className="mt-10 grid md:grid-cols-2 gap-6">
        {products.map((p) => (
          <div key={p.id} data-testid={`product-${p.key}`} className="border border-[#E5E7EB] rounded-lg bg-white overflow-hidden">
            <div className="bg-[#0A4F35] px-6 py-5">
              <h2 className="font-display text-2xl font-bold text-white">{p.name}</h2>
            </div>
            <div className="p-6">
              <div className="flex items-baseline gap-2">
                <span className="text-sm uppercase tracking-widest text-slate-400">From</span>
                <span className="font-display text-3xl font-extrabold text-[#0A4F35]">{naira(p.price_per_litre)}</span>
                <span className="text-slate-400">per litre</span>
              </div>
              <p className="mt-3 text-sm text-slate-500">Minimum order: {p.min_order_litres?.toLocaleString()} litres</p>
              <Link to={`/request-fuel?fuel=${p.key}`}>
                <Button className="mt-6 w-full bg-[#E5B800] hover:bg-[#CCA300] text-black font-semibold">Request {p.name}</Button>
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] p-6">
        <p className="text-sm text-slate-600">
          {settings.indicative_note || "Prices are indicative and may be negotiated depending on quantity, location and commercial agreement."}
        </p>
      </div>
    </div>
  );
}
